import React from "react";
//import { Link } from "react-router-dom";
import SingleMenu from "../../components/SingleMenu/singlemenu";
import { useEffect, useState, useMemo } from "react";
import "./MyButton.css";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { base_api_url } from "../../../environment.jsx";
import MenuHeader from "../../../InitialPage/Sidebar/MenuHeader.jsx";
import AddOrder from "../../../core/modals/menus/addorder";
import CartSidePanel from "../../components/CartSidePanel/CartSidePanel.jsx";
// import StartModal from "../../../core/modals/menus/startmodal.jsx";
// import { Modal } from "bootstrap";
import { Skeleton } from 'antd';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import SessionClient from "../../components/SessionControl/sessionclient.jsx";
import { Check, ChevronDown, ChevronUp, Clock, RefreshCw, ShoppingBag } from "feather-icons-react/build/IconComponents/index.js";
// import PWAInstall from "../../components/PWAInstall.tsx";
// import { usePWA } from "../../../hooks/usePWA.js";


const Homemenu = () => {
  const MySwal = withReactContent(Swal);

  const [searchParams] = useSearchParams();
  const [category, setCategory] = useState("");
  const [isSelected, setIsSelected] = useState("");
  const [articles, setarticles] = useState([]);
  const [categorie, setcategorie] = useState([]);
  const [typeCategories, setTypeCategories] = useState([]); // New state for type categories
  const [reload, setReload] = useState(false); //pour rafrechir quand on insere
  const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingArticles, setLoadingArticles] = useState(false);
  const [renderingComplete, setRenderingComplete] = useState(false);

  // New states for menu management
  const [menus, setMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedMenuData, setSelectedMenuData] = useState(null); // Add state to store full menu data
  const [loadingMenus, setLoadingMenus] = useState(false);
  const [viewMode, setViewMode] = useState('menus'); // 'menus' or 'articles'

  const restau = searchParams.get("r");
  const table = searchParams.get("t");
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cartQuantity, setCartQuantity] = useState(0); // New state for cart quantity
  const [devise, setDevise] = useState("€"); // Default devise
  const [showInfoModal, setShowInfoModal] = useState(false); // New state for info modal
  const [trackingReference, setTrackingReference] = useState(""); // State for tracking reference input
  const [trackingLoading, setTrackingLoading] = useState(false); // Loading state for tracking
  const [trackingOrderData, setTrackingOrderData] = useState(null); // Order data for tracking
  const [showTrackingModal, setShowTrackingModal] = useState(false); // Show tracking modal
  const [trackingExpandedOrder, setTrackingExpandedOrder] = useState(null); // Expanded order in tracking
  const [tableData, setTableData] = useState(null); // Store table information
  const [relatedCommandsData, setRelatedCommandsData] = useState(null); // Store related commands
  const [showRelatedCommandsModal, setShowRelatedCommandsModal] = useState(false); // Modal visibility
  const [loadingRelatedCommands, setLoadingRelatedCommands] = useState(false); // Loading state
  const [trackingRefreshing, setTrackingRefreshing] = useState(false); // Refreshing state for tracking

  // Debug PWA
  // const pwaData = usePWA();
  // console.log('PWA Data dans Homemenu:', pwaData);

  // 🔄 NETTOYAGE : Vérifier si le restaurant a changé et nettoyer les données
  useEffect(() => {
    const lastRestaurantId = localStorage.getItem('last_restaurant_id');
    const currentRestaurantId = restau?.toString();

    // Si on change de restaurant, nettoyer toutes les données
    if (lastRestaurantId && currentRestaurantId && lastRestaurantId !== currentRestaurantId) {
      console.log('🔄 Changement de restaurant détecté:', {
        ancien: lastRestaurantId,
        nouveau: currentRestaurantId
      });

      // Nettoyer sessionStorage
      sessionStorage.removeItem('client');
      sessionStorage.removeItem('selectedMenu');
      sessionStorage.removeItem('demo_payment');

      // Nettoyer localStorage (sauf les infos du restaurant actuel)
      localStorage.removeItem('total');
      localStorage.removeItem('quantite');
      localStorage.removeItem('stripe_session');
      localStorage.removeItem('table_id');
      localStorage.removeItem("restaurant");
      localStorage.removeItem('type_table'); // Nettoyer le type de table

      // Reset le panier
      setCartQuantity(0);

      console.log('✅ Données du restaurant précédent nettoyées');
    }

    // Sauvegarder le restaurant actuel
    if (currentRestaurantId) {
      localStorage.setItem('last_restaurant_id', currentRestaurantId);
      if (table) localStorage.setItem('table_id', table);
    }
  }, [restau, table]);

  // Load initial cart quantity
  useEffect(() => {
    const loadInitialCartQuantity = async () => {
      const client = JSON.parse(sessionStorage.getItem("client"));
      if (client?.reference) {
        try {
          const response = await axios.get(
            `${base_api_url}api/commande/${client.reference}`
          );
          console.log("Initial cart quantity response:", response.data);

          // Handle successful responses (200, 201)
          if (response.status === 200 || response.status === 201) {
            const totalQuantity =
              response.data.details?.reduce((total, detail) => {
                return total + (detail.quantite || 0);
              }, 0) || 0;
            console.log("Total quantity in cart:", totalQuantity);
            setCartQuantity(totalQuantity);
          }
        } catch (error) {
          console.error("Error loading initial cart quantity:", error);

          let errorMessage = "Impossible de charger le panier.";

          if (error.response) {
            const status = error.response.status;

            switch (status) {
              case 404:
                // Commande non trouvée - cas normal pour un nouveau panier
                console.log("No existing cart found - this is normal for new sessions");
                setCartQuantity(0);
                return; // Don't show error for this case

              case 401:
                errorMessage = "Session expirée. Veuillez rafraîchir la page.";
                break;

              case 500:
                errorMessage = "Erreur du serveur lors du chargement du panier.";
                break;

              default:
                errorMessage = "Une erreur inattendue s'est produite.";
            }
          } else if (error.request) {
            errorMessage = "Problème de connexion. Vérifiez votre internet.";
          }

          // Show error notification only for actual errors (not 404)
          if (error.response?.status !== 404) {
            MySwal.fire({
              icon: "error",
              // title: "Erreur de chargement du panier",
              text: errorMessage,
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                popup: "pixel-toast",
              },
            });
          }

          // Set cart to 0 on any error
          setCartQuantity(0);
        }
      }
    };

    loadInitialCartQuantity();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "en_attente": return "#ffc107";
      case "en_preparation": return "#007bff";
      case "prete": return "#28a745";
      case "pret": return "#28a745";
      default: return "#6c757d";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "en_attente": return "En attente";
      case "en_preparation": return "En préparation";
      case "prete": return "Prête";
      case "pret": return "Prêt";
      default: return status;
    }
  };



  // Ajout d'un effet pour mettre à jour la quantité du panier lorsque le modal est fermé
  useEffect(() => {
    const updateCartQuantity = async () => {
      const client = JSON.parse(sessionStorage.getItem("client"));
      if (client?.reference) {
        try {
          const response = await axios.get(
            `${base_api_url}api/commande/${client.reference}`
          );

          // Handle successful responses (200, 201)
          if (response.status === 200 || response.status === 201) {
            const totalQuantity =
              response.data.details?.reduce((total, detail) => {
                return total + (detail.quantite || 0);
              }, 0) || 0;
            setCartQuantity(totalQuantity);
            console.log("Updated cart quantity:", totalQuantity);
          }
        } catch (error) {
          console.error("Error updating cart quantity:", error);

          let errorMessage = "Impossible de mettre à jour le panier.";
          let showError = true;

          if (error.response) {
            const status = error.response.status;

            switch (status) {
              case 404:
                // Commande non trouvée - réinitialiser le panier
                console.log("Cart not found during update - resetting to 0");
                setCartQuantity(0);
                showError = false; // Don't show error for missing cart
                break;

              case 401:
                errorMessage = "Session expirée. Veuillez rafraîchir la page.";
                break;

              case 500:
                errorMessage = "Erreur du serveur lors de la mise à jour du panier.";
                break;

              default:
                errorMessage = "Une erreur inattendue s'est produite.";
            }
          } else if (error.request) {
            errorMessage = "Problème de connexion. Vérifiez votre internet.";
          }

          // Show error notification only for actual errors
          if (showError) {
            MySwal.fire({
              icon: "error",
              // title: "Erreur de mise à jour du panier",
              text: errorMessage,
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                popup: "pixel-toast",
              },
            });
          }
        }
      }
    };

    // Update cart quantity when modal is closed
    if (!showModal) {
      updateCartQuantity();
    }
  }, [showModal]);

  // Ajout d'un effet pour rafraîchir la quantité du panier toutes les 30 secondes
  useEffect(() => {
    const refreshCartQuantity = async () => {
      const client = JSON.parse(sessionStorage.getItem("client"));
      if (client?.reference) {
        try {
          const response = await axios.get(
            `${base_api_url}api/commande/${client.reference}`
          );

          // Handle successful responses (200, 201)
          if (response.status === 200 || response.status === 201) {
            const totalQuantity =
              response.data.details?.reduce((total, detail) => {
                return total + (detail.quantite || 0);
              }, 0) || 0;

            // Mettre à jour la quantité du panier si elle a changé
            if (totalQuantity !== cartQuantity) {
              setCartQuantity(totalQuantity);
              console.log("Cart quantity refreshed:", totalQuantity);
            }
          }
        } catch (error) {
          console.error("Error refreshing cart quantity:", error);

          // For refresh errors, only handle critical cases silently
          if (error.response) {
            const status = error.response.status;

            switch (status) {
              case 404:
                // Cart not found - reset quietly
                if (cartQuantity > 0) {
                  setCartQuantity(0);
                  console.log("Cart not found during refresh - reset to 0");
                }
                break;

              case 401:
                // Session expired - show critical error
                MySwal.fire({
                  icon: "warning",
                  // title: "Session expirée",
                  text: "Votre session a expiré. Veuillez rafraîchir la page.",
                  toast: true,
                  position: "bottom-end",
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  customClass: {
                    popup: "pixel-toast",
                  },
                });
                break;

              default:
                // Other errors - log silently for background refresh
                console.log("Silent error during cart refresh:", status);
            }
          }
        }
      }
    };

    // Configuration de l'intervalle pour rafraîchir la quantité du panier toutes les 30 secondes
    const interval = setInterval(refreshCartQuantity, 30000);

    // Nettoyer l'intervalle lors du démontage du composant
    return () => clearInterval(interval);
  }, [cartQuantity]);

  // Fetch table data to check if it's type 3 (QR Code table)
  useEffect(() => {
    const fetchTableData = async () => {
      if (!table) return;

      try {
        const response = await axios.get(`${base_api_url}api/tables/${table}`);
        if (response.data && response.data.table) {
          setTableData(response.data.table);
          console.log('Table data:', response.data.table);
        }
      } catch (error) {
        console.error('Error fetching table data:', error);
      }
    };

    fetchTableData();
  }, [table]);

  // Handle successful order - update cart quantity
  const handleOrderSuccess = async (newQuantity) => {
    console.log("Order success callback triggered with quantity:", newQuantity);

    // Si newQuantity est défini, mettre à jour la quantité du panier
    // Sinon, récupérer la quantité du panier depuis l'API
    if (newQuantity !== undefined) {
      setCartQuantity(newQuantity);
    } else {
      // Recupérer la quantité du panier depuis l'API
      const client = JSON.parse(sessionStorage.getItem("client"));
      if (client?.reference) {
        try {
          const response = await axios.get(
            `${base_api_url}api/commande/${client.reference}`
          );
          const totalQuantity =
            response.data.details?.reduce((total, detail) => {
              return total + (detail.quantite || 0);
            }, 0) || 0;
          setCartQuantity(totalQuantity);
          console.log("Fresh cart quantity fetched:", totalQuantity);
        } catch (error) {
          console.error("Error fetching fresh cart quantity:", error);
        }
      }
    }
  };

  // Ajouter la fonction de fermeture du modal
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedArticle(null);

    // Déclencher une mise à jour du panier après la fermeture du modal
    setTimeout(async () => {
      const client = JSON.parse(sessionStorage.getItem("client"));
      if (client?.reference) {
        try {
          const response = await axios.get(
            `${base_api_url}api/commande/${client.reference}`
          );

          // Handle successful responses (200, 201)
          if (response.status === 200 || response.status === 201) {
            const totalQuantity =
              response.data.details?.reduce((total, detail) => {
                return total + (detail.quantite || 0);
              }, 0) || 0;
            setCartQuantity(totalQuantity);
            console.log("Cart quantity updated after modal close:", totalQuantity);
          }
        } catch (error) {
          console.error("Error updating cart after modal close:", error);

          // Handle errors silently for modal close updates
          if (error.response?.status === 404) {
            setCartQuantity(0);
            console.log("Cart not found after modal close - reset to 0");
          } else if (error.response?.status === 401) {
            MySwal.fire({
              icon: "warning",
              // title: "Session expirée",
              text: "Votre session a expiré. Veuillez rafraîchir la page.",
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              customClass: {
                popup: "pixel-toast",
              },
            });
          }
        }
      }
    }, 500);
  };

  // Handle rendering complete after articles are loaded
  useEffect(() => {

    if (articles.length > 0 && !loadingArticles && viewMode === 'articles') {
      // Add a small delay to ensure DOM rendering is complete
      const timer = setTimeout(() => {
        setRenderingComplete(true);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [articles, loadingArticles, viewMode]);

  useEffect(() => {
    if (selectedMenu) {
      FetchArticles();
    }
  }, [selectedMenu]);

  // Charger les menus et categories au chargement du composant
  useEffect(() => {
    if (restau) {
      fetchMenus(restau);
      fetchCategories(restau);
      fetchTypeCategories(); // Add this new function call
    }
  }, [restau, reload]);

  const effectOnModal = () => {
    setReload(!reload); // Force la mise à jour de la liste
  };

  const populatedTypeCategories = useMemo(() => {
    // If we're loading or have no articles yet, show all categories to avoid flickering
    if (loadingArticles || articles.length === 0) return typeCategories;
    
    // Filter typeCategories to only include those that have at least one article
    return typeCategories.filter(typecat => 
      articles.some(article => article.categorie?.[0]?.id_type === typecat.id)
    );
  }, [typeCategories, articles, loadingArticles]);

  useEffect(() => {
    if (populatedTypeCategories.length > 0) {
      // Find if current category is still in populated list
      const currentStillExists = populatedTypeCategories.some(cat => cat.nom === category);
      
      if (!currentStillExists) {
        // Set default to first populated type category
        const firstPopulatedCategory = populatedTypeCategories[0];
        setCategory(firstPopulatedCategory.nom);
        setIsSelected(firstPopulatedCategory.nom);
      }
    }
  }, [populatedTypeCategories, category]); // Changed dependency


  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setIsSelected(newCategory);
  };

  // New function to fetch menus
  const fetchMenus = async (restau) => {
    setLoadingMenus(true);
    try {
      const response = await axios.get(
        `${base_api_url}api/listMenu/${restau}/1`
      );

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        console.log("Réponse API :", response.data.menu);
        localStorage.removeItem("restaurant")
        const current_devise = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise || JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;

        if (current_devise) {
          console.log("Devise from localStorage:", current_devise);
          setDevise(current_devise); // Fixer la devise depuis les infos du restaurant
        } else {
          console.log("Fetching restaurant details for devise...");
          try {
            console.log('restau id:', restau);
            const restoDetails = await axios.get(`${base_api_url}api/restaurant/${restau}`);
            localStorage.setItem("restaurant", JSON.stringify(restoDetails.data));
            setDevise(restoDetails.data?.restaurant?.devise); // Prendre la devise depuis les détails du restaurant
          } catch (deviseError) {
            console.error("Error fetching restaurant details for devise:", deviseError);
            setDevise("€"); // Fallback to default currency
          }
        }

        // liste des menus
        const menusData = response.data.menu || [];
        setMenus(menusData);

        // Show info notification if no menus found
        if (menusData.length === 0) {
          MySwal.fire({
            icon: "info",
            // title: "Aucun menu disponible",
            text: "Ce restaurant n'a pas encore de menus disponibles.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching menus:", error);

      //       let errorTitle = "Erreur de chargement des menus";
      let errorMessage = "Impossible de charger les menus du restaurant.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 404:
            //             errorTitle = "Restaurant introuvable";
            errorMessage = "Ce restaurant n'existe pas ou n'a pas de menus disponibles.";
            break;

          case 403:
            //             errorTitle = "Accès refusé";
            errorMessage = "Vous n'avez pas accès aux menus de ce restaurant.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des menus.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error to prevent UI issues
      setMenus([]);
      setDevise("€"); // Set default currency on error
    } finally {
      setLoadingMenus(false);
    }
  };

  // pour le chargement des categories
  const fetchCategories = async (restau) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${base_api_url}api/categorie/${restau}`
      );
      setcategorie(response.data.categorie); // stocker toutes les catégories
      console.log("Catégories chargées :", response.data.categorie);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // New function to fetch type categories
  const fetchTypeCategories = async () => {
    try {
      const response = await axios.get(`${base_api_url}api/typecategorie`);

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        console.log("Type catégories chargées :", response.data);
        const typeData = response.data || [];
        setTypeCategories(typeData);

        // Show info notification if no type categories found
        if (typeData.length === 0) {
          MySwal.fire({
            icon: "info",
            // title: "Aucun type de catégorie",
            text: "Aucun type de catégorie disponible.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching type categories:", error);

      //       let errorTitle = "Erreur de chargement des types";
      let errorMessage = "Impossible de charger les types de catégories.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 401:
            //             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
            break;

          case 404:
            //             errorTitle = "Types introuvables";
            errorMessage = "Aucun type de catégorie trouvé.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des types.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error
      setTypeCategories([]);
    }
  };

  // Function to handle menu selection
  const handleMenuSelect = async (menu) => {
    // Check if client session exists
    const client = sessionStorage.getItem("client");

    if (!client) {
      // Create command automatically in background
      const commandCreatedSuccessfully = await createCommandAutomatically();

      // Si la création a échoué, ne pas continuer
      if (!commandCreatedSuccessfully) {
        return;
      }
    }

    // NOUVEAU : Stocker le menu sélectionné dans sessionStorage
    sessionStorage.setItem("selectedMenu", JSON.stringify(menu));

    // Maintenant que le client existe, on peut sélectionner le menu
    setSelectedMenu(menu);
    setLoadingArticles(true);
    setViewMode('articles');

    // Simulate loading time or actual data processing
    setTimeout(() => {
      setLoadingArticles(false);
      setRenderingComplete(true);
    }, 500); // Adjust timing as needed
  };

  const createCommandAutomatically = async () => {
    try {
      // Fetch table information first
      const tableResponse = await axios.get(`${base_api_url}api/tables/${table}`);
      const tableData = tableResponse.data.table;

      // récupérer les details du restaurant pour la prise_cmd
      const restaurantResponse = await axios.get(`${base_api_url}api/restaurant/${restau}`);
      const restaurantData = restaurantResponse.data.restaurant;

      // Utiliser la timezone locale pour comparer les dates
      const now = new Date();
      const priseCmdDate = new Date(restaurantData.prise_cmd);

      if (priseCmdDate < now) {

        // Prepare command data
        const commandData = {
          nom: `Table N°${tableData?.numero_table || table}`,
          id_restaurant: restau,
          numtable: tableData?.numero_table || table,
        };

        // Create the command
        const response = await axios.post(
          `${base_api_url}api/commande`,
          commandData
        );

        // Handle successful responses (200, 201)
        if (response.status === 200 || response.status === 201) {
          // Save client data to session
          sessionStorage.setItem("client", JSON.stringify(response.data));
          console.log("Command created automatically:", response.data);

          // Show success toast
          MySwal.fire({
            icon: "success",
            // title: "Bienvenue !",
            text: "Votre commande a été initialisée.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });

          // Retourner true pour indiquer le succès
          return true;
        }
      } else {
        // Show info toast about command not allowed yet
        MySwal.fire({
          icon: "info",
          // title: "Prise de commande non disponible",
          text: `La prise de commande débutera le ${priseCmdDate.toLocaleString('fr-FR', {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}.`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          customClass: {
            popup: "small-toast",
          },
        });

        // Retourner false pour indiquer l'échec
        return false;
      }

    } catch (error) {
      console.error("Error creating command automatically:", error);

      //       let errorTitle = "Erreur d'initialisation";
      let errorMessage = "Impossible d'initialiser votre commande.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 400:
            //             errorTitle = "Données invalides";
            errorMessage = errorData?.message || "Les données de la table sont invalides.";
            break;

          case 404:
            //             errorTitle = "Table introuvable";
            errorMessage = "Cette table n'existe pas dans le système.";
            break;

          case 409:
            //             errorTitle = "Commande existante";
            errorMessage = "Une commande existe déjà pour cette table.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Retourner false pour indiquer l'échec
      return false;
    }
  };

  const fetchRelatedCommands = async () => {
    console.log('Fetching related commands for table:', tableData);
    if (!tableData || !tableData.id_table) return;

    setLoadingRelatedCommands(true);
    try {
      const response = await axios.get(
        `${base_api_url}api/commande_table/${tableData.numero_table}/${restau}`
      );

      if (response.data) {
        console.log('Related commands data:', response.data);
        setRelatedCommandsData(response.data);
        setShowRelatedCommandsModal(true);
      }
    } catch (error) {
      console.error('Error fetching related commands:', error);
      if (error.status === 404) {
        MySwal.fire({
          icon: 'info',
          title: 'Aucune commande associée',
          text: 'Aucune commande trouvée pour cette table.',
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {

        MySwal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Impossible de charger les commandes associées.',
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } finally {
      setLoadingRelatedCommands(false);
    }
  };

  const handleCloseRelatedCommandsModal = () => {
    setShowRelatedCommandsModal(false);
  };


  const formatPrice = (price) => {
    if (price === null || price === undefined) return '--';
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;
    return isNaN(numPrice) ? '--' : `${numPrice.toLocaleString('fr-FR')} ${devise}`;
  };



  const getStatusLabel = (statut, statutPaiement) => {
    if (statut == 10) return 'À valider';
    if (statut == 2 || statut == 3) return 'En préparation';
    if (statut == 4 && (statutPaiement == 1 || statutPaiement == 2)) return 'À servir';
    if (statut == 5 && statutPaiement == 1) return 'À encaisser';
    if (statut == 5 && statutPaiement == 2) return 'Terminée';
    if (statut == 0) return 'Annulée';
    return 'Inconnu';
  };




  // Function to go back to menus view
  const handleBackToMenus = () => {
    setSelectedMenu(null);
    sessionStorage.removeItem("selectedMenu"); // Nettoyer
    setViewMode('menus');
    
    // Reset to first populated type category if available
    if (populatedTypeCategories.length > 0) {
      const firstTypeCategory = populatedTypeCategories[0];
      setCategory(firstTypeCategory.nom);
      setIsSelected(firstTypeCategory.nom);
    }
  };

  // Function to check if menu is available based on current day and time
  const isMenuAvailable = (menuData) => {
    if (!menuData) return false;

    // Check if menu is generally available
    if (!menuData.disponible) return false;

    const now = new Date();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const currentTime = now.toTimeString().slice(0, 5); // Format: "HH:MM"

    // Map days to menu availability properties
    const dayMapping = {
      0: menuData.dispo_dim,  // Sunday
      1: menuData.dispo_lun,  // Monday
      2: menuData.dispo_mar,  // Tuesday
      3: menuData.dispo_mer,  // Wednesday
      4: menuData.dispo_jeu,  // Thursday
      5: menuData.dispo_ven,  // Friday
      6: menuData.dispo_sam   // Saturday
    };

    // Check if menu is available for current day
    if (!dayMapping[currentDay]) {
      return false;
    }

    // Check time availability if start and end times are defined
    if (menuData.heure_debut && menuData.heure_fin) {
      const startTime = menuData.heure_debut;
      const endTime = menuData.heure_fin;

      // Compare times as strings (works for HH:MM format)
      if (currentTime < startTime || currentTime > endTime) {
        return false;
      }
    }

    return true;
  };

  const FetchArticles = async () => {
    setLoadingArticles(true);
    try {
      const response = await axios.get(
        `${base_api_url}api/menu-details/${selectedMenu?.id_menu}`
      );

      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        console.log("Réponse API :", response.data);

        // Store the full menu data for availability checking
        setSelectedMenuData(response.data.menu);

        // Transform the new data structure to match the existing article format
        const transformedArticles = [];

        if (response.data.contenu && Array.isArray(response.data.contenu)) {
          response.data.contenu.forEach(typeCategory => {
            if (typeCategory.categories && Array.isArray(typeCategory.categories)) {
              typeCategory.categories.forEach(category => {
                if (category.articles && Array.isArray(category.articles)) {
                  category.articles.forEach(article => {
                    // Transform each article to match the existing structure
                    const transformedArticle = {
                      id_article: article.id_article,
                      nom: article.nom,
                      description: article.description || article.ingredients,
                      prix_unitaire: article.prix_unitaire,
                      quantite_defaut: article.quantite || "1",
                      image_url: article.image_url && article.image_url.startsWith('data:image') ? article.image_url : `${base_api_url}api/recuperer/${article.image_url}`,
                      disponible: article.disponible,
                      // Add category information in the expected format
                      categorie: [{
                        id_categorie: category.id_categorie,
                        nom: category.nom,
                        description: category.description,
                        id_type: category.id_type || null
                      }],
                      // Add any additional fields that might be needed
                      autre: article.autre,
                      ingredients: article.ingredients,
                      id_restaurant: article.id_restaurant
                    };

                    transformedArticles.push(transformedArticle);
                  });
                }
              });
            }
          });
        }

        console.log("Transformed articles:", transformedArticles);
        setarticles(transformedArticles);

        // Update categories based on the new structure
        const uniqueCategories = [];
        const categoryMap = new Map();

        response.data.contenu?.forEach(typeCategory => {
          typeCategory.categories?.forEach(category => {
            if (!categoryMap.has(category.id_categorie)) {
              categoryMap.set(category.id_categorie, {
                id_categorie: category.id_categorie,
                nom: category.nom,
                description: category.description
              });
              uniqueCategories.push({
                id_categorie: category.id_categorie,
                nom: category.nom,
                description: category.description
              });
            }
          });
        });

        // Update categories state if needed (only if not already set)
        if (uniqueCategories.length > 0 && categorie.length === 0) {
          setcategorie(uniqueCategories);
        }

        // Show info notification if no articles found for this menu
        if (transformedArticles.length === 0) {
          MySwal.fire({
            icon: "info",
            // title: "Aucun article",
            text: "Ce menu ne contient pas encore d'articles.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching articles:", error);

      //       let errorTitle = "Erreur de chargement des articles";
      let errorMessage = "Impossible de charger les articles de ce menu.";

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        switch (status) {
          case 404:
            //             errorTitle = "Menu ou articles introuvables";
            errorMessage = "Ce menu n'existe pas ou ne contient pas d'articles.";
            break;

          case 403:
            //             errorTitle = "Accès refusé";
            errorMessage = "Vous n'avez pas accès aux articles de ce menu.";
            break;

          case 500:
            //             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
            break;

          case 503:
            //             errorTitle = "Service indisponible";
            errorMessage = "Le service est temporairement indisponible. Veuillez réessayer plus tard.";
            break;

          default:
            //             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des articles.";
        }
      } else if (error.request) {
        //         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }

      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });

      // Set empty array on error to prevent UI issues
      setarticles([]);
    } finally {
      setLoadingArticles(false);
    }
  };
  console.log("mes articles", articles);

  {/*// Filter articles by selected menu
  const getFilteredArticles = () => {
    if (!selectedMenu) return [];
    
    return articles.filter(article => 
      article.menu && article.menu.some(menu => menu.id_menu === selectedMenu.id_menu)
    );
  };
*/}

  // Skeleton component for menu cards
  const MenuCardSkeleton = () => (
    <div className="col-md-6 col-lg-4 mb-4">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '15px',
        padding: '25px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        height: '200px'
      }}>
        <Skeleton.Input
          active
          size="default"
          style={{ width: '100%', marginBottom: '15px', height: '24px' }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: '80%', marginBottom: '15px' }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: '60%', marginBottom: '20px' }}
        />
        <Skeleton.Button
          active
          size="default"
          style={{ width: '120px', height: '36px' }}
        />
      </div>
    </div>
  );

  // Skeleton component for menu items
  const MenuItemSkeleton = () => (
    <div className="col-md-6 mb-4">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{ flex: 1 }}>
            <Skeleton.Input
              active
              size="small"
              style={{ width: '80%', marginBottom: '8px' }}
            />
            <Skeleton.Input
              active
              size="small"
              style={{ width: '60%', marginBottom: '8px' }}
            />
            <Skeleton.Input
              active
              size="small"
              style={{ width: '40%' }}
            />
          </div>
          <Skeleton.Avatar
            size={60}
            shape="square"
            style={{ borderRadius: '8px' }}
          />
        </div>
      </div>
    </div>
  );

  // Skeleton component for category tabs
  const CategoryTabsSkeleton = () => (
    <div className="py-2 flex-wrap items-center row d-flex justify-content-center">
      {[...Array(5)].map((_, index) => (
        <div key={index} className="col-auto text-center g-3 mt-4">
          <Skeleton.Button
            active
            size="default"
            style={{
              width: '80px',
              height: '36px',
              borderRadius: '20px',
              marginRight: '16px'
            }}
          />
        </div>
      ))}
    </div>
  );

  // Function to handle order tracking
  const handleTrackOrder = async () => {
    if (!trackingReference.trim()) return;
    setTrackingLoading(true);
    try {
      const response = await axios.get(`${base_api_url}api/commande/${trackingReference.trim()}`);
      if (response.status === 200 || response.status === 201) {
        setTrackingOrderData(response.data);
        setShowTrackingModal(true);
      } else {
        MySwal.fire({
          icon: "error",
          // title: "Commande introuvable",
          text: "Aucune commande trouvée pour cette référence.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: { popup: "pixel-toast" }
        });
      }
    } catch (error) {
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Impossible de retrouver la commande. Vérifiez la référence ou réessayez.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" }
      });
    } finally {
      setTrackingLoading(false);
    }
  };

  // Function to refresh tracking command data
  const handleRefreshTrackingCommand = async () => {
    if (!trackingOrderData?.reference) return;
    setTrackingRefreshing(true);
    try {
      const response = await axios.get(`${base_api_url}api/commande/${trackingOrderData.reference}`);
      if (response.status === 200 || response.status === 201) {
        setTrackingOrderData(response.data);
      } else {
        MySwal.fire({
          icon: "error",
          // title: "Commande introuvable",
          text: "Aucune commande trouvée pour cette référence.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: { popup: "pixel-toast" }
        });
      }
    } catch (error) {
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Impossible d'actualiser la commande. Réessayez.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" }
      });
    } finally {
      setTrackingRefreshing(false);
    }
  };

  // Function to handle quick add to cart (no modal at all)
  const handleQuickAdd = async (article) => {
    // Ensure a command reference exists — create one silently if not
    let reference = JSON.parse(sessionStorage.getItem("client"))?.reference;
    if (!reference) {
      MySwal.fire({
        title: 'Initialisation...',
        text: 'Préparation de votre commande',
        allowOutsideClick: false,
        didOpen: () => { MySwal.showLoading(); }
      });
      const success = await createCommandAutomatically();
      if (!success) return; // createCommandAutomatically already shows an error
      reference = JSON.parse(sessionStorage.getItem("client"))?.reference;
      if (!reference) {
        MySwal.fire({
          icon: "error",
          text: "Impossible d'initialiser la commande. Veuillez réessayer.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          customClass: { popup: "pixel-toast" }
        });
        return;
      }
    }

    try {
      MySwal.fire({
        title: 'Ajout en cours...',
        allowOutsideClick: false,
        didOpen: () => { MySwal.showLoading(); }
      });

      const response = await axios.post(
        `${base_api_url}api/detailscmd/${article.id_article}/${selectedMenu?.id_menu}/${reference}`,
        { "commentaire": " ", "prix_unitaire": article.prix_unitaire, "quantite": 1 }
      );

      if (response.status === 200 || response.status === 201) {
        // Increment cart badge by 1 directly — avoids re-fetch and wrong-key issues
        setCartQuantity(prev => (prev || 0) + 1);

        MySwal.fire({
          icon: "success",
          text: "Article ajouté au panier !",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
          customClass: { popup: "pixel-toast" }
        });
      }
    } catch (error) {
      console.error("Error Quick Add:", error);
      let errorMessage = "Impossible d'ajouter l'article au panier.";
      if (error.response?.data?.message) errorMessage = error.response.data.message;
      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        customClass: { popup: "pixel-toast" }
      });
    }
  };

  // useEffect pour restaurer le menu depuis sessionStorage au montage
  useEffect(() => {
    const savedMenu = sessionStorage.getItem("selectedMenu");
    if (savedMenu && viewMode === 'menus') {
      // On vient de revenir du panier, restaurer le menu
      try {
        const menu = JSON.parse(savedMenu);
        setSelectedMenu(menu);
        setLoadingArticles(true);
        setViewMode('articles');

        setTimeout(() => {
          setLoadingArticles(false);
          setRenderingComplete(true);
        }, 500);
      } catch (error) {
        console.error("Erreur lors de la restauration du menu:", error);
      }
    }
  }, []);

  if (!restau || !table) {
    return (
      <div className="page">
        <div
          className="content text-center"
          style={{
            minHeight: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <h3 className=" text-primary">
            Ooups!!! Scanner le code QR
          </h3>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page">
        <SessionClient redirectTo={`/homemenu?r=${restau}&t=${table}`} />
        <div
          className="content"
          style={{
            backgroundColor: '#EEEEEE',
            ...(viewMode === 'menus' && {
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 1000,
              overflow: "auto",
              padding: 0,
              margin: 0
            })
          }}
        >
          {viewMode === 'menus' ? (
            // Menus view — hero header + full-width rounded buttons
            <>
              {loadingMenus ? (
                <div style={{ padding: "20px" }}>
                  <div className="row">
                    {[...Array(6)].map((_, index) => (
                      <MenuCardSkeleton key={index} />
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  {/* Hero header */}
                  <div style={{ borderRadius: 0, overflow: "hidden", margin: 0, boxShadow: "none" }}>
                    <div style={{ width: "100%", height: 300, overflow: "hidden", background: "#f4f4f6" }}>
                      <img
                        src="/assets/img/client_home.jpg"
                        alt={
                          (JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.nom) ||
                          (JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.nom) ||
                          menus[0]?.nom ||
                          "Restaurant"
                        }
                        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                      />
                    </div>

                    <div style={{ background: "#fff", padding: "18px 16px" }}>
                      <div style={{ width: "100%" }}>
                        <div>
                          <h2 style={{ margin: 0, color: "#FF6A3D", fontSize: "30px", fontWeight: 700 }}>
                            {JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.nom ||
                              JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.nom ||
                              menus[0]?.nom ||
                              "Le restaurant"}
                          </h2>
                          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8, color: "#666", fontSize: 14 }}>
                            {/* <span style={{ color: "#ff9900", fontSize: 16 }}>★</span> */}
                            <span style={{ fontWeight: 700, fontSize: 20 }}>
                              {JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.rating || "4,9"}
                            </span>
                            <span style={{ color: "#666", fontSize: 20 }}>• Excellent</span>
                          </div>
                          <div style={{ color: "#888", fontSize: 16, marginTop: 8 }}>43 notes</div>
                        </div>
                        <hr></hr>
                        {/* Full-width category buttons */}
                        <div style={{ padding: "0 16px 16px" }}>
                          {menus.map((menu) => (
                            <button
                              key={menu.id_menu}
                              onClick={() => handleMenuSelect(menu)}
                              style={{
                                width: "100%",
                                height: 55,
                                background: "#FF732E",
                                color: "#fff",
                                border: "none",
                                borderRadius: 28,
                                padding: "12px 18px",
                                fontSize: 17,
                                fontWeight: 500,
                                marginBottom: 12,
                                boxShadow: "0 6px 18px rgba(255,106,61,0.18)",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                            >
                              {menu.nom}
                            </button>
                          ))}
                        </div>

                        {/* Suivi de commande section */}
                        <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid #f0f0f0", width: "100%" }}>
                          <div style={{ marginBottom: 16 }}>
                            <h3 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#222", marginBottom: 8 }}>
                              Suivre votre commande
                            </h3>
                            <p style={{ margin: 0, color: "#777", fontSize: 14, marginBottom: 16 }}>
                              Entrez votre référence de commande pour consulter son statut
                            </p>

                            <div style={{ display: "flex", gap: "8px", alignItems: "stretch" }}>
                              <input
                                type="text"
                                placeholder="Ex: ABC123..."
                                value={trackingReference}
                                onChange={(e) => setTrackingReference(e.target.value)}
                                style={{
                                  flex: 1,
                                  padding: "12px 16px",
                                  border: "2px solid #f0f0f0",
                                  borderRadius: "12px",
                                  fontSize: "16px",
                                  fontFamily: "monospace",
                                  fontWeight: "600",
                                  color: "#333",
                                  backgroundColor: "#fff",
                                  outline: "none",
                                  transition: "border-color 0.2s ease"
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = "#FF6A3D";
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = "#f0f0f0";
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter' && trackingReference.trim()) {
                                    handleTrackOrder();
                                  }
                                }}
                              />
                              <button
                                onClick={handleTrackOrder}
                                disabled={!trackingReference.trim() || trackingLoading}
                                style={{
                                  padding: "12px 20px",
                                  backgroundColor: trackingReference.trim() && !trackingLoading ? "#FF6A3D" : "#f0f0f0",
                                  color: trackingReference.trim() && !trackingLoading ? "#fff" : "#999",
                                  border: "none",
                                  borderRadius: "12px",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  cursor: trackingReference.trim() && !trackingLoading ? "pointer" : "not-allowed",
                                  transition: "all 0.2s ease",
                                  minWidth: "80px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                              >
                                {trackingLoading ? (
                                  <div style={{
                                    width: "16px",
                                    height: "16px",
                                    border: "2px solid #fff",
                                    borderTop: "2px solid transparent",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite"
                                  }}></div>
                                ) : (
                                  "Suivre"
                                )
                                }
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Informations section */}
                        <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid #f0f0f0", width: "100%" }}>
                          <div
                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                            onClick={() => setShowInfoModal(true)}
                          >
                            <div>
                              <h3 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#222" }}>Informations</h3>
                              <p style={{ margin: "4px 0 0 0", color: "#777", fontSize: 16 }}>
                                Wifi, téléphone, adresse du restaurant
                              </p>
                            </div>
                            <span style={{ color: "#ccc", fontSize: 18 }}>›</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </>
              )}
            </>
          ) : (
            // Articles view
            <>
              <div className="d-flex align-items-center mb-3 mt-3" style={{ paddingInline: '10px' }}>
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={handleBackToMenus}
                  style={{ borderRadius: '5px' }}
                >
                  ← Menus
                </button>
                <h1 className="mb-0 ms-auto" style={{ fontSize: "16px" }}>
                  {selectedMenu?.nom}
                </h1>
                {/* Related Commands Button - Only show for QR Code tables (type_table === 3) */}
                {tableData && tableData.type_table === 3 && (
                  <button
                    className="btn-related-commands"
                    onClick={fetchRelatedCommands}
                    disabled={loadingRelatedCommands}
                  >
                    {loadingRelatedCommands ? (
                      <>
                        <div className="btn-spinner-small"></div>
                        Chargement...
                      </>
                    ) : (
                      <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="3" width="7" height="7" rx="1" />
                          <rect x="14" y="3" width="7" height="7" rx="1" />
                          <rect x="14" y="14" width="7" height="7" rx="1" />
                          <rect x="3" y="14" width="7" height="7" rx="1" />
                        </svg>
                        Mes commandes
                      </>
                    )}
                  </button>
                )}
              </div>

              {/* Loading state for categories */}
              {loading ? (
                <CategoryTabsSkeleton />
              ) : (
                /* Updated mobile-responsive tabs container */
                <div className="menu-tabs-container" style={{ position: 'relative', width: "100%", maxWidth: "100%", margin: "0 auto" }}>
                  <div className="menu-tabs-row flex-wrap items-center row d-flex justify-content-center" style={{ paddingTop: '8px', paddingBottom: '8px' }}>
                    {populatedTypeCategories.map((typecat) => (
                      <div key={typecat.id} className="menu-tab-item col-auto text-center mb-2" style={{ padding: '0 4px' }}>
                        <button
                          className={`btn btn-m rounded-full text-sm ${isSelected === typecat.nom ? "active" : ""} menu-button`}
                          onClick={() => handleCategoryChange(typecat.nom)}
                          style={{
                            height: '36px',
                            minWidth: '80px',
                            marginRight: '8px',
                            paddingLeft: '16px',
                            paddingRight: '16px',
                            fontSize: '14px',
                            borderRadius: '20px'
                          }}
                        >
                          {typecat.nom}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="mt-4">
                {loadingArticles || !renderingComplete ? (
                  <div className="row">
                    {[...Array(6)].map((_, index) => (
                      <MenuItemSkeleton key={index} />
                    ))}
                  </div>
                ) : (
                  <div>
                    {(() => {
                      // Filter articles first - removed "Tous" check
                      const filteredArticles = articles.filter((menu) => {
                        // Find the type category ID for the selected category name
                        const selectedTypeCategory = typeCategories.find(typecat => typecat.nom === category);
                        if (!selectedTypeCategory) return false;

                        // Check if the article's category has the matching id_type
                        return menu.categorie?.[0]?.id_type === selectedTypeCategory.id;
                      });

                      // Group articles by category name
                      const groupedArticles = filteredArticles.reduce((groups, article) => {
                        const categoryName = article.categorie?.[0]?.nom || "Autres";
                        if (!groups[categoryName]) {
                          groups[categoryName] = [];
                        }
                        groups[categoryName].push(article);
                        return groups;
                      }, {});

                      // Sort category names alphabetically
                      const sortedCategoryNames = Object.keys(groupedArticles).sort();

                      return sortedCategoryNames.map((categoryName) => (
                        <div key={categoryName} className="mb-5">
                          {/* Category Header */}
                          <div className="category-header mb-3" style={{
                            borderBottom: '2px solid #f0f0f0',
                            paddingBottom: '10px',
                            marginBottom: '20px'
                          }}>
                            <h3 style={{
                              fontSize: '20px',
                              fontWeight: '600',
                              color: '#333',
                              margin: 0,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}>
                              <span style={{
                                backgroundColor: '#FF4500',
                                color: '#fff',
                                width: '8px',
                                height: '24px',
                                borderRadius: '4px',
                                display: 'inline-block'
                              }}></span>
                              {categoryName}
                              <span style={{
                                backgroundColor: '#f8f9fa',
                                color: '#6c757d',
                                fontSize: '12px',
                                fontWeight: '500',
                                padding: '4px 8px',
                                borderRadius: '12px',
                                marginLeft: '8px'
                              }}>
                                {groupedArticles[categoryName].length} article{groupedArticles[categoryName].length > 1 ? 's' : ''}
                              </span>
                            </h3>
                          </div>

                          {/* Articles in this category */}
                          <div className="row">
                            {groupedArticles[categoryName].map((menu) => {
                              // Check both article availability and menu availability
                              const isArticleAvailable = menu.disponible;
                              const isCurrentMenuAvailable = isMenuAvailable(selectedMenuData);
                              const isOverallAvailable = isArticleAvailable && isCurrentMenuAvailable;

                              return (
                                <div key={menu.id_article} className="col-12 col-md-4 col-lg-3" style={{ marginBottom: "32px" }}>
                                  <div 
                                  style={{
                                    opacity: isOverallAvailable ? 1 : 0.6,
                                    filter: isOverallAvailable ? 'none' : 'grayscale(50%)',
                                    position: 'relative'
                                  }}>
                                    {!isOverallAvailable && (
                                      <div style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '10px',
                                        backgroundColor: '#dc3545',
                                        color: '#fff',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        padding: '4px 8px',
                                        borderRadius: '12px',
                                        zIndex: 2
                                      }}>
                                        {!isArticleAvailable ? 'Indisponible' :
                                          !isCurrentMenuAvailable ? 'Menu fermé' : 'Indisponible'}
                                      </div>
                                    )}
                                    <SingleMenu
                                      title={menu.nom}
                                      underTitle={<> {menu.prix_unitaire} {devise} <span></span> </>}
                                      // underTitle={<> {menu.prix_unitaire} {devise} <span></span> • {menu.quantite_defaut} pièce</>}
                                      description={menu.description}
                                      section={menu.image_url}
                                      onFormSubmit={effectOnModal}
                                      showAddButton={isOverallAvailable} // Pass overall availability to control button display
                                      onselect={isOverallAvailable ? () => {
                                        // Simply show the order modal - command already exists
                                        setSelectedArticle(menu);
                                        setShowModal(true);
                                      } : undefined} // Only allow selection if overall available
                                      onAdd={isOverallAvailable ? () => {
                                        handleQuickAdd(menu);
                                      } : undefined}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ));
                    })()}

                    {/* Show message if no articles found */}
                    {articles.filter((menu) => {
                      const selectedTypeCategory = typeCategories.find(typecat => typecat.nom === category);
                      if (!selectedTypeCategory) return false;
                      return menu.categorie?.[0]?.id_type === selectedTypeCategory.id;
                    }).length === 0 && (
                        <div className="text-center py-5">
                          <div style={{
                            color: '#6c757d',
                            fontSize: '16px'
                          }}>
                            <i className="las la-utensils" style={{ fontSize: '48px', marginBottom: '16px', display: 'block' }}></i>
                            <p>Aucun article disponible pour cette sélection.</p>
                          </div>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </>
          )}
          {selectedArticle && (
            <AddOrder
              article={selectedArticle}
              menu={selectedMenu}
              show={showModal}
              onHide={handleModalClose}
              onOrderSuccess={handleOrderSuccess}
            />
          )}

          {/* Order Tracking Modal - copied and adapted from end-order.jsx */}
          {showTrackingModal && trackingOrderData && (
            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Statut de la commande #{trackingOrderData.reference}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowTrackingModal(false);
                        setTrackingOrderData(null);
                        setTrackingReference("");
                      }}
                    ></button>
                  </div>
                  <div className="card modal-body custom-modal-body">
                    {/* En-tête avec statut et bouton refresh */}
                    <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap">
                      <div className="flex-grow-1">
                        <p className="text-secondary mb-2">
                          Etat de la commande : <span className="badge rounded-pill" style={{ 
                             backgroundColor: trackingOrderData?.statut == 4 || (trackingOrderData?.statut == 5 && trackingOrderData?.statut_paiement == 2) ? "#28a745" : 
                                              trackingOrderData?.statut == 2 || trackingOrderData?.statut == 10 || trackingOrderData?.statut == 3 ? "#ffc107" : "#6c757d",
                             color: "#fff",
                             fontWeight: "bold"
                           }}>
                             {getStatusLabel(trackingOrderData?.statut, trackingOrderData?.statut_paiement)}
                           </span>
                        </p>
                        <small className="text-muted d-block">
                          Dernière mise à jour: {new Date().toLocaleTimeString('fr-FR', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </small>
                      </div>

                      <button
                        className="btn btn-outline-primary btn-sm d-flex align-items-center"
                        onClick={handleRefreshTrackingCommand}
                        disabled={trackingRefreshing}
                        style={{
                          borderRadius: "20px",
                          padding: "5px 5px 5px 13px",
                          fontSize: "13px",
                          fontWeight: "500",
                          border: "1px solid #FF4500",
                          backgroundColor: trackingRefreshing ? "#f8f9fa" : "transparent",
                          color: trackingRefreshing ? "#6c757d" : "#FF4500",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <RefreshCw
                          size={14}
                          className={`me-2 ${trackingRefreshing ? 'rotating' : ''}`}
                          style={{
                            animation: trackingRefreshing ? 'spin 1s linear infinite' : 'none'
                          }}
                        />
                        <span className="d-none d-sm-inline">
                          {trackingRefreshing ? "Actualisation..." : "Actualiser"}
                        </span>
                        <span className="d-sm-none">
                          {trackingRefreshing ? "..." : ""}
                        </span>
                      </button>
                    </div>

                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <div className="card mb-3 shadow-sm">
                          <div
                            className="card-header bg-white border-bottom cursor-pointer"
                            onClick={() => setTrackingExpandedOrder(
                              trackingExpandedOrder === trackingOrderData.id_commande ? null : trackingOrderData.id_commande
                            )}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h6 className="mb-1">#{trackingOrderData.reference}</h6>
                                <small className="text-muted">{trackingOrderData.numtable} • {trackingOrderData.nom}</small>
                              </div>
                              <div className="text-end">
                                <div className="fw-bold">{trackingOrderData.prix} {devise}</div>
                                <small className="text-muted d-flex align-items-center">
                                  <Clock size={12} className="me-1" />
                                  {new Date(trackingOrderData.date_commande).toLocaleTimeString('fr-FR', {
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}
                                </small>
                              </div>
                            </div>
                            <div className="mt-2 d-flex justify-content-flex-end align-items-center">
                              {trackingExpandedOrder === trackingOrderData.id_commande ?
                                <ChevronUp size={16} /> : <ChevronDown size={16} />}
                            </div>
                            {trackingExpandedOrder === trackingOrderData.id_commande && (
                              <div className="card-body">
                                <h6 className="mb-3">Articles de la commande:</h6>
                                {trackingOrderData.notes && (
                                  <div style={{
                                    backgroundColor: '#223b6b9c',
                                    paddingInline: '5px',
                                    marginBottom: '5px',
                                    borderRadius: '5px',
                                    color: '#fff'
                                  }}>
                                    <strong>Note:</strong> {trackingOrderData.notes}
                                  </div>
                                )}
                                {trackingOrderData.details?.map((article) => (
                                  <div key={article.id} className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                    <div className="flex-grow-1">
                                      <div className="fw-semibold">{article.article[0].nom}</div>
                                      <small className="text-muted">
                                        Quantité: {article?.quantite} • {article?.prix_unitaire} {devise}
                                      </small>
                                    </div>

                                    <div className="d-flex align-items-center gap-2">
                                      <span
                                        className="badge rounded-pill"
                                        style={{
                                          backgroundColor: getStatusColor(
                                            (trackingOrderData?.statut == 4 || trackingOrderData?.statut == 5) ? "pret" :
                                              ((article.statut || article.etat) == 1 || (article.statut || article.etat) == 10) ? "en_attente" :
                                                ((article.statut || article.etat) == 2 || (article.statut || article.etat) == 3) ? "en_preparation" : "pret"
                                          ),
                                          color: '#fff'
                                        }}
                                      >
                                        {getStatusText(
                                          (trackingOrderData?.statut == 4 || trackingOrderData?.statut == 5) ? "pret" :
                                            ((article.statut || article.etat) == 1 || (article.statut || article.etat) == 10) ? "en_attente" :
                                              ((article.statut || article.etat) == 2 || (article.statut || article.etat) == 3) ? "en_preparation" : "pret"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="btn btn-secondary btn-cancel"
                        onClick={() => {
                          setShowTrackingModal(false);
                          setTrackingOrderData(null);
                          setTrackingReference("");
                        }}
                      >
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showTrackingModal && <div className="modal-backdrop fade show"></div>}

          {/* Restaurant Information Modal */}
          {showInfoModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 10000,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
              }}
              onClick={() => setShowInfoModal(false)}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "16px 16px 0 0",
                  width: "100%",
                  maxWidth: "420px",
                  padding: "20px",
                  maxHeight: "70vh",
                  overflow: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Modal header */}
                <div style={{ textAlign: "center", marginBottom: 20 }}>
                  <div
                    style={{
                      width: 40,
                      height: 4,
                      backgroundColor: "#ccc",
                      borderRadius: 2,
                      margin: "0 auto 16px",
                    }}
                  ></div>
                  <h2 style={{ margin: 0, color: "#FF6A3D", fontSize: 20, fontWeight: 600 }}>
                    Infos pratiques
                  </h2>
                </div>

                {/* WiFi Info */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
                    <div>
                      <div style={{ color: "#666", fontSize: 14, marginBottom: 4 }}>Mot de passe wifi:</div>
                      <div style={{ color: "#333", fontSize: 16, fontWeight: 500 }}>
                        {JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.wifi_password ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.wifi_password ||
                          "Boabapresto001"}
                      </div>
                    </div>
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: 18,
                        color: "#666",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const password = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.wifi_password ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.wifi_password ||
                          "Boabapresto001";
                        navigator.clipboard.writeText(password);
                        MySwal.fire({
                          icon: "success",
                          // title: "Copié!",
                          text: "Mot de passe WiFi copié dans le presse-papiers",
                          toast: true,
                          position: "bottom-end",
                          showConfirmButton: false,
                          timer: 2000,
                          timerProgressBar: true,
                          customClass: { popup: "pixel-toast" }
                        });
                      }}
                    >
                      📋
                    </button>
                  </div>
                </div>

                {/* Phone Info */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
                    <div>
                      <div style={{ color: "#333", fontSize: 16, fontWeight: 500 }}>
                        {JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.telephone ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.telephone ||
                          "+33 6 50 38 71 82"}
                      </div>
                    </div>
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: 18,
                        color: "#666",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const phone = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.telephone ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.telephone ||
                          "+33 6 50 38 71 82";
                        window.location.href = `tel:${phone}`;
                      }}
                    >
                      📞
                    </button>
                  </div>
                </div>

                {/* Address Info */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0" }}>
                    <div>
                      <div style={{ color: "#333", fontSize: 16, fontWeight: 500 }}>
                        {JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.adresse ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.adresse ||
                          "19 Avenue des Monty, Paris"}
                      </div>
                    </div>
                    <button
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: 18,
                        color: "#666",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const address = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.adresse ||
                          JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.adresse ||
                          "19 Avenue des Monty, Paris";
                        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
                        window.open(mapsUrl, '_blank');
                      }}
                    >
                      🗺️
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Ajout du composant PWA */}
      {/* <PWAInstall /> */}

      {viewMode === 'articles' && (
        <>
          <MenuHeader
            restauId={restau}
            Table={table}
            cartQuantity={cartQuantity}
            onCartClick={() => setIsCartPanelOpen(true)}
          />
          <CartSidePanel
            isOpen={isCartPanelOpen}
            onClose={() => setIsCartPanelOpen(false)}
            restauId={restau}
            Table={table}
            onCartUpdate={(qty) => setCartQuantity(qty)}
          />
        </>
      )}

      {/* Related Commands Modal - Payment Interface */}
      {showRelatedCommandsModal && relatedCommandsData && (
        <div className="payment-modal-overlay" onClick={handleCloseRelatedCommandsModal}>
          <div className="payment-modal-container" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header - Discreet */}
            <div className="payment-modal-header">
              <button
                className="payment-modal-close"
                onClick={handleCloseRelatedCommandsModal}
              >
                ×
              </button>
            </div>

            {/* Summary Section - Match Reference Image */}
            <div className="payment-summary-section">
              <div className="payment-summary-card payment-already-paid">
                <div className="payment-summary-label">RÉGLÉ</div>
                <div className="payment-summary-value">
                  {formatPrice(relatedCommandsData.prix_total_consommer || 0)}
                </div>
              </div>
              <div className="payment-summary-card payment-to-settle">
                <div className="payment-summary-label">À RÉGLER</div>
                <div className="payment-summary-value">
                  {formatPrice((relatedCommandsData.prix_total_previsionnel || 0) - (relatedCommandsData.prix_total_consommer || 0))}
                </div>
              </div>
            </div>

            {/* Vos consommations Section */}
            <div className="payment-commands-scroll">
              <div className="payment-section-title">
                <span className="payment-icon" style={{
                  color: '#FF6A3D',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingBag size={20} />
                </span>
                <span style={{ marginLeft: '10px' }}>Vos consommations</span>
              </div>

              {relatedCommandsData.commandes && relatedCommandsData.commandes.length > 0 ? (
                relatedCommandsData.commandes.map((cmd) => {
                  const cmdTotal = cmd.details?.reduce((acc, art) => acc + (art.prix_total || 0), 0) || cmd.prix || 0;
                  const statusLabel = getStatusLabel(cmd.statut, cmd.statut_paiement);
                  const isPaid = cmd.statut_paiement === 2;

                  return (
                    <div key={cmd.id_commande} className={`payment-command-card ${isPaid ? 'is-paid' : ''}`}>
                      {/* Command Header - High Fidelity Structure */}
                      <div className="payment-command-header">
                        <div className="payment-command-info">
                          <span className="payment-command-ref">
                            {cmd.reference || `CMD-${cmd.id_commande}`}
                          </span>
                          <span className="payment-command-time">
                            {new Date(cmd.date_commande).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </div>
                        <div className="payment-command-total">
                          {cmdTotal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€
                        </div>
                      </div>

                      <div className="payment-command-header" style={{ marginTop: '-4px', marginBottom: '16px' }}>
                        <div className="payment-status-badge-container">
                          <span className={`payment-status-badge ${isPaid ? 'paid' : ''}`}>
                            {isPaid ? <Check size={10} style={{ opacity: 0.7 }} /> : <Clock size={10} style={{ opacity: 0.7 }} />}
                            {isPaid ? 'PAYÉ' : statusLabel}
                          </span>
                        </div>
                        <div className="payment-command-chevron">
                          <ChevronUp size={18} />
                        </div>
                      </div>

                      {/* Articles List */}
                      {Array.isArray(cmd.details) && cmd.details.length > 0 && (
                        <div className="payment-articles-list">
                          {cmd.details.map((art, idx) => {
                            return (
                              <div
                                key={idx}
                                className={`payment-article-row static ${isPaid ? 'is-validated' : ''}`}
                              >
                                <div className="payment-article-circle">
                                  <div className="circle-icon selected"></div>
                                </div>
                                <div className="payment-article-qty">
                                  x{art.quantite}
                                </div>
                                <div className="payment-article-name">
                                  {art.article?.nom || art.article?.[0]?.nom || 'Article'}
                                </div>
                                <div className="payment-article-price">
                                  {(art.prix_total || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="payment-empty-state">
                  <p>Aucune commande trouvée</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* StartModal kept for backward compatibility but no longer auto-shown */}
      {/* <StartModal restauId={restau} Table={table} /> */}
    </>
  );
};

export default Homemenu;